import React, { useEffect, useRef } from "react";
import "./App.css";
// import VideoSection from  './component/VideoSection'
// import Participate from  './component/Participate'
import { useGaTag } from "./libs/ga";
import { Criteo_trackEvent } from "./libs/criteo";

import { RouterProvider } from "react-router";
import router from "./router";



export function useTrackregisterBtn() {
  return useEffect(() => {
    document.addEventListener("click", (ev) => {
      console.log(ev.target);
      if (ev.target.getAttribute("data-event-id") == "register") {
        Criteo_trackEvent("viewItem", {
          item: 1,
        });
        console.log("tracked");
      }
    });
  }, []);
}

const PromoVideoSection = () => {
  return (
    <div className="container">
      <iframe
        className="video-size--classic embed--md"
        width="100%"
        src={`https://www.youtube.com/embed/5dHwEPXaBnY?autoplay=0&rel=0&loop=1&playlist=5dHwEPXaBnY`}
        title="Charak"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  )
}

function App() {
  useGaTag();
  useTrackregisterBtn();
  const myRef = useRef(null);
  const JurySelect = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  const JurySelectScroll = () => JurySelect.current.scrollIntoView();
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
